module.exports = __webpack_public_path__ + "img/jxjy.17af84c0.png";